import { render } from "./AttributeEditor.vue?vue&type=template&id=1b9dd4ee&scoped=true"
import script from "./AttributeEditor.vue?vue&type=script&lang=js"
export * from "./AttributeEditor.vue?vue&type=script&lang=js"

import "./AttributeEditor.vue?vue&type=style&index=0&id=1b9dd4ee&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9dd4ee"]])

export default __exports__